/* eslint-disable func-names */
/* eslint-disable no-plusplus, no-bitwise */
export default function(cardNumber) {
  const prodArr = [
    [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
    [0, 2, 4, 6, 8, 1, 3, 5, 7, 9]
  ];
  let len = cardNumber.length;
  let mul = 0;
  let sum = 0;

  while (len--) {
    sum += prodArr[mul][parseInt(cardNumber.charAt(len), 10)];
    mul ^= 1;
  }

  return sum % 10 === 0 && sum > 0;
}
